export default __webpack_public_path__ + "static/media/circle.44466e4b.png";